import { render, staticRenderFns } from "./LearningRequestFormCreateV2.vue?vue&type=template&id=6b4c7aff&"
import script from "./LearningRequestFormCreateV2.vue?vue&type=script&lang=ts&"
export * from "./LearningRequestFormCreateV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports